<template>
  <van-popup :value="value" position="bottom" round @input="$emit('input', $event)"
             :style="{ height: 'auto' }" :class="mode === 'handle' ? 'handle-popup' : 'detail-popup'">

    <div class="detail-popup-header">
      <span class="detail-popup-title">{{ mode === 'handle' ? '处理告警' : '告警记录详情' }}</span>
      <van-icon name="cross" size="22" class="detail-popup-close" @click="close" />
    </div>
    <div class="detail-popup-body">
      <div class="detail-hospital-row">
        <van-icon name="location-o" class="detail-hospital-icon" />
        <span class="detail-hospital-name">{{ alarmData.tenantName || '-' }}</span>
      </div>
      <div class="detail-grid">
        <div class="detail-grid-item">
          <span class="detail-grid-label">告警名称</span>
          <span class="detail-grid-value">{{ alarmData.alarmName || '-' }}</span>
        </div>
        <div class="detail-grid-item">
          <span class="detail-grid-label">处理状态</span>
          <span class="detail-status-tag" :class="mode === 'handle' ? 'status-pending' : 'status-processed'">
            {{ mode === 'handle' ? '未处理' : '已处理' }}
          </span>
        </div>
        <div class="detail-grid-item">
          <span class="detail-grid-label">触发值范围</span>
          <span class="detail-grid-value">{{ triggerRangeText }}</span>
        </div>
        <div class="detail-grid-item">
          <span class="detail-grid-label">达标值范围</span>
          <span class="detail-grid-value">{{ factorRangeText }}</span>
        </div>
        <div class="detail-grid-item detail-grid-full">
          <span class="detail-grid-label">异常时间段</span>
          <span class="detail-grid-value">{{ timeRangeText }}</span>
        </div>
      </div>

      <div class="detail-divider"></div>

      <template v-if="mode === 'handle'">
        <div class="detail-form-group">
          <div class="detail-form-group-title">处理人</div>
          <van-field v-model="formData.userName" placeholder="请输入处理人姓名" />
        </div>

        <div class="detail-form-group">
          <div class="detail-form-group-title">处理描述</div>
          <van-field v-model="formData.measures" type="textarea" placeholder="请输入处理描述" rows="3" autosize />
        </div>

        <div class="detail-form-actions">
          <van-button class="btn-confirm" @click="onSubmit">处理</van-button>
        </div>
      </template>

      <template v-else>
        <div class="detail-grid">
          <div class="detail-grid-item">
            <span class="detail-grid-label">处理人</span>
            <span class="detail-grid-value">{{ alarmData.userName || '-' }}</span>
          </div>
          <div class="detail-grid-item">
            <span class="detail-grid-label">处理时间</span>
            <span class="detail-grid-value">{{ alarmData.updateTime || '-' }}</span>
          </div>
        </div>

        <div class="detail-section">
          <div class="detail-section-title">
            <van-icon name="description" />
            <span>处理描述</span>
          </div>
          <div class="detail-section-card">
            {{ alarmData.measures || '暂无描述' }}
          </div>
        </div>
      </template>
    </div>
  </van-popup>
</template>

<script>
  import { Dialog } from 'vant';

export default {
  name: 'AlarmDetailPopup',
  props: {
    value: { type: Boolean, default: false },
    mode: { type: String, default: 'handle' },
    alarmData: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      formData: { userName: '', measures: '' },
    };
  },
  computed: {
    triggerRangeText() {
      const item = this.alarmData;
      const isEmpty = v => v === null || v === undefined || v === '';
      if (!isEmpty(item.minValue) && !isEmpty(item.maxValue)) {
        return item.minValue + ' ~ ' + item.maxValue + (item.factorUnit || '');
      }
      return '-';
    },
    factorRangeText() {
      const item = this.alarmData;
      const isEmpty = v => v === null || v === undefined || v === '';
      if (isEmpty(item.rangeValue)) {
        return '-';
      }
      try {
        const parsed = JSON.parse(item.rangeValue);
        if (Array.isArray(parsed) && parsed.length >= 2) {
          return parsed[0] + ' ~ ' + parsed[1] + (item.factorUnit || '');
        }
      } catch (e) {}
      return item.rangeValue;
    },
    timeRangeText() {
      const item = this.alarmData;
      if (item.alarmStartTime && item.alarmEndTime) {
        return item.alarmStartTime + ' ~ ' + item.alarmEndTime;
      }
      return '-';
    },
  },
  watch: {
    value(val) {
      if (val && this.mode === 'handle') {
        this.formData = {
          userName: this.alarmData.userName || '',
          measures: this.alarmData.measures || '',
        };
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    onSubmit() {
      if (!this.formData.userName) {
        Dialog.alert({ title: '提示', message: '请输入处理人姓名' });
        return;
      }
      this.formData.id = this.alarmData.id;
      this.$emit('submit', { ...this.formData });
      this.close();
    },
  },
};
</script>

<style lang="less" scoped>
.detail-popup,
.handle-popup {
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.detail-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 32px 20px;
  border-bottom: 1px solid #F0F2F5;
  flex-shrink: 0;
}

.detail-popup-title {
  font-size: 32px;
  font-weight: 600;
  color: #1a365d;
}

.detail-popup-close {
  color: #909399;
  cursor: pointer;
  padding: 4px;
}

.detail-popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px 28px 28px;
}

.detail-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px 0;
}

.detail-grid-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 50%;
  padding-right: 32px;
  box-sizing: border-box;
}

.detail-grid-item.detail-grid-full {
  width: 100%;
  padding-right: 0;
}

.detail-grid-label {
  font-size: 24px;
  color: #909399;
}

.detail-grid-value {
  font-size: 28px;
  color: #303133;
  font-weight: 500;
  word-break: break-all;
}

.detail-status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  width: fit-content;

  &.status-pending {
    background: #FFF0F0;
    color: #FF4D4F;
  }
  &.status-processed {
    background: #F6FFED;
    color: #52C41A;
  }
}

.detail-hospital-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
}

.detail-hospital-icon {
  font-size: 28px;
  color: #1B75F6;
}

.detail-hospital-name {
  font-size: 28px;
  color: #303133;
  font-weight: 600;
}

.detail-divider {
  height: 1px;
  background: #EBEEF5;
  margin: 24px 0;
}

.detail-form-group {
  margin-bottom: 24px;
}

.detail-form-group-title {
  font-size: 26px;
  color: #303133;
  font-weight: 600;
  margin-bottom: 12px;
}

.detail-form-group ::v-deep .van-field {
  border: 1px solid #EBEEF5;
  border-radius: 12px;
  padding: 8px 14px;
  background: #F8FAFC;
}

.detail-form-actions {
  display: flex;
  gap: 20px;
  margin-top: 32px;
  padding-bottom: env(safe-area-inset-bottom);
}

.detail-form-actions .btn-confirm {
  flex: 1;
  height: 72px;
  font-size: 28px;
  font-weight: 600;
  border-radius: 36px;
  border: none;
  background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
  color: #fff;
}

.detail-section {
  margin-top: 28px;
}

.detail-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 26px;
  font-weight: 600;
  color: #1a365d;
  margin-bottom: 14px;

  .van-icon {
    color: #1B75F6;
  }
}

.detail-section-card {
  background: #F8FAFC;
  border-radius: 12px;
  padding: 20px 24px;
  font-size: 26px;
  color: #303133;
  line-height: 1.6;
  border: 1px solid #EBEEF5;
}
</style>
